import {writable} from "svelte/store";


/**
 *
 *

 */
export const dataBox = writable({
    navigation : {
        label: 'No Content',
        description:'',
        children : []
        /*
        label: 'Applications used for Vaildation',
        description:'',
        children : [
            {
                label: 'Application Descriptions And Variants',
                description:' Contains samples of complete application and variant models based on the mimesis metamodel proposed in the thesis. The applications are fully self-contained. In Addition, modules are listed here that represent just portions of an application and are made for integration into composite applications as components.' +
                    '         For each application you find below a short description card indicating special features it demonstrates. In Addition links are given, that call a live Version of the application, live versions of variants and Links to the descriptions used to generate the application.\n' +
                    '         ' +
                    '<br><b>Additional Inspection Section: </b> Most applications provide an <I>Inspection</I> page at the bottom of the navigation, which offers a glance at the collected data at runtime, the application model, combined application model and variant description used to generate the application. Additionally the AUI model can be inspected and onthological representations of application model and collected instance data used as sharable models. If an application contains such a section, this is mentiened in the application card.' +
                    '<br><b>Ontology for Collected Data: </b> For all applications ontological representations of the application model can be generated. Some applications are completely prepared to produce Instances for a request Ontology. This is indicated here. If the application has an additional Inspection Section, the Ontology for Collected Data can be inspected there.\n' +
                    '<br><b>Commented Version: </b>Some  applications provide a <I>Commented UI</I>. This means, that the version shows Remarks in light grey within the UI for explanatory reasons. If an application contains such a section, this is mentiened in the application card.\n',
                children : [
                    'liability_val',
                    'travelinsurance_val',
                    'flightbookingbasic_val'
                ]
            },
            {
                label: 'Compositions and Customisations',
                description:'',
                children : [
                    'flightbooking_insured_val',
                    'tripbooking_val'
                ]
            },
            {
                label: 'Components for reuse',
                description:'Contains (partial) applications, that can be reused as components in compositions. Some of them are potentially usable as standalone applications, some are explicitely made for integration.',
                children:[
                    'module_payments_val',
                    'module_carrental_val',
                    'module_overnightstay_val',
                    'module_events_val',
                    'module_babysitting_val'
                ]
            },
            {
                label: 'Showcase Applications',
                description:'Illustrative showcases unsed to test different aspects of the implementation.',
                children:[
                    'showcase_interaction_val',
                    'showcase_variants_val',
                    'showcase_combination_val'
                ]
            }
        ]*/
    }
});
